import { FC, useState } from 'react';
import {
  Button,
  Container,
  Form,
  SpaceBetween,
  Textarea
} from '@cloudscape-design/components';
import { useOktaAuth } from '@okta/okta-react';
import type { GcpCertRejectionRequest } from '../../../types/gcpCert';
import useRejectGcpCert from "../../../hooks/mutate/useRejectGcpCert";

interface RejectionFormProps {
  thisgcpCertID: string;
  shouldShowRejectionForm: (shouldShow: boolean) => void
}

const GcpCertRejectionForm: FC<RejectionFormProps> = ({ thisgcpCertID, shouldShowRejectionForm }) => {
    const { authState } = useOktaAuth()
	const thisUserEmail = authState?.idToken?.claims.email as string

	const [commentText, setCommentText] = useState('')

	const { mutate: rejectGcpCert, isLoading } = useRejectGcpCert(thisgcpCertID)

  const _handleReject = () => {
    const rejectionPayload: GcpCertRejectionRequest = {
        gcpCertID: thisgcpCertID,
        commenterID: thisUserEmail,
        action: "REJECT",
        comment: commentText,
        timestamp: new Date().toISOString(),
    };

    rejectGcpCert(rejectionPayload, {
			onSuccess: () => {
				shouldShowRejectionForm(false)
				setCommentText('')
			}
		})
	}

  return (
		<Form
			actions={
				<SpaceBetween direction="horizontal" size="xs">
					<Button variant="link" onClick={() => shouldShowRejectionForm(false)}>
						Cancel
					</Button>
					<Button variant="primary" loading={isLoading} onClick={_handleReject}>
						Reject
					</Button>
				</SpaceBetween>
			}
		>
			<Container>
				<SpaceBetween direction="vertical" size="l">
					<Textarea
						onChange={({ detail }) => setCommentText(detail.value)}
						value={commentText}
						placeholder="Reason for rejection"
					/>
				</SpaceBetween>
			</Container>
		</Form>
	)
}

export default GcpCertRejectionForm;